import Combine from '../../components/Combine/Combine'
import AboutUs from './AboutUs'

const About = () => {
  return (
    <Combine>
      <AboutUs/>
    </Combine>
  )
}

export default About
